"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonGateEmbed = void 0;
class MoonGateEmbed {
    constructor() {
        this._ready = false;
        this.listeners = {};
        this.commandQueue = [];
        window.addEventListener("message", this.handleMessage.bind(this));
        this.iframeOrigin = new URL("https://wallet.moongate.one/").origin;
        this.iframe = this.createIframe();
        this.minimizeButton = this.createMinimizeButton();
    }
    isMobileDevice() {
        return window.matchMedia("(max-width: 767px)").matches;
    }
    createIframe() {
        const iframe = document.createElement("iframe");
        iframe.src = "https://wallet.moongate.one/";
        iframe.sandbox;
        iframe.style.position = "fixed";
        iframe.style.top = "50%";
        iframe.style.left = "50%";
        iframe.style.transform = "translate(-50%, -50%)";
        iframe.style.width = "500px";
        iframe.style.height = "600px";
        iframe.style.zIndex = "999999";
        iframe.style.border = "none";
        iframe.style.backgroundColor = "transparent";
        iframe.sandbox.value = "allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation allow-popups-to-escape-sandbox";
        iframe.allow = "clipboard-write; clipboard-read;";
        iframe.onload = () => {
            var _a;
            (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({
                type: "initIframe",
                data: { origin: window.location.origin },
            }, this.iframeOrigin);
        };
        if (this.isMobileDevice()) {
            iframe.style.top = "0";
            iframe.style.left = "0";
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.transform = "";
        }
        document.body.appendChild(iframe);
        return iframe;
    }
    moveModal(corner = "top-right") {
        if (!this.isMobileDevice()) {
            this.iframe.style.transform = "";
            switch (corner) {
                case "top-left":
                    this.setPosition(this.iframe, "10px", "auto", "10px", "auto");
                    this.setPosition(this.minimizeButton, "10px", "auto", "10px", "auto");
                    break;
                case "top-right":
                    this.setPosition(this.iframe, "10px", "10px", "auto", "auto");
                    this.setPosition(this.minimizeButton, "10px", "10px", "auto", "auto");
                    break;
                case "bottom-left":
                    this.setPosition(this.iframe, "auto", "auto", "10px", "10px");
                    this.setPosition(this.minimizeButton, "auto", "auto", "10px", "10px");
                    break;
                case "bottom-right":
                    this.setPosition(this.iframe, "auto", "10px", "auto", "10px");
                    this.setPosition(this.minimizeButton, "auto", "10px", "auto", "10px");
                    break;
                default:
                    console.error("Invalid corner specified for moveModal method");
                    break;
            }
        }
        else {
            this.setPosition(this.minimizeButton, "auto", "auto", "10px", "10px");
        }
    }
    setPosition(element, top, right, left, bottom) {
        element.style.top = top;
        element.style.right = right;
        element.style.left = left;
        element.style.bottom = bottom;
    }
    createMinimizeButton() {
        const imgButton = document.createElement("img");
        imgButton.src = "https://i.ibb.co/NjxF2zw/Image-3.png";
        imgButton.style.position = "fixed";
        imgButton.style.display = "none";
        imgButton.style.width = "50px";
        imgButton.style.height = "50px";
        imgButton.style.zIndex = "1000000";
        imgButton.style.cursor = "pointer";
        imgButton.addEventListener("click", this.toggleIframe.bind(this));
        document.body.appendChild(imgButton);
        return imgButton;
    }
    toggleIframe() {
        if (this.iframe.style.display === "none") {
            this.iframe.style.display = "block";
            this.minimizeButton.style.display = "none";
        }
        else {
            this.iframe.style.display = "none";
            this.minimizeButton.style.display = "block";
        }
    }
    handleMessage(event) {
        if (event.origin !== this.iframeOrigin)
            return;
        const { type, data } = event.data;
        if (type === "minimizeIframe") {
            this.toggleIframe();
            return;
        }
        if (type === "disconnect") {
            this.disconnect();
            return;
        }
        if (type === "iframeReady") {
            this._ready = true;
            this.processQueue();
            return;
        }
        if (this.listeners[type]) {
            this.listeners[type](data);
        }
    }
    processQueue() {
        var _a;
        while (this.commandQueue.length && this._ready) {
            const { command, data, resolve } = this.commandQueue.shift();
            const responseType = `${command}Response`;
            if (!this.listeners[responseType]) {
                this.listeners[responseType] = resolve;
                (_a = this.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ type: command, data }, this.iframeOrigin);
            }
        }
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("Starting the disconnection process...");
            this.iframe.remove();
            if (this.minimizeButton) {
                this.minimizeButton.remove();
            }
            this._ready = false;
        });
    }
    sendCommand(command, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.iframe.style.display === "none") {
                this.toggleIframe();
            }
            const responseType = `${command}Response`;
            const origin = window.location.origin;
            return new Promise((resolve, reject) => {
                var _a;
                if (!this._ready) {
                    this.commandQueue.push({ command, data, resolve, reject });
                    setTimeout(() => {
                        reject(new Error("Iframe did not respond in time"));
                    }, 120000);
                }
                else {
                    if (!this.listeners[responseType]) {
                        this.listeners[responseType] = (responseData) => {
                            resolve(responseData);
                            delete this.listeners[responseType];
                        };
                    }
                    (_a = this.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ type: command, data, origin }, this.iframeOrigin);
                }
            });
        });
    }
}
exports.MoonGateEmbed = MoonGateEmbed;
